import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Btn, Spinner } from '../../../../../AbstractElements';
import { Card, CardBody, Col, Table, Form, FormGroup, Label, Row, CardHeader } from 'reactstrap';
import axios from 'axios';
import config from '../../../../../config';
import { toast } from 'react-toastify';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';

const dropdownItemStyle = {
    padding: '10px 14px',
    cursor: 'pointer',
    fontSize: '14px',
    backgroundColor: '#fff'
};

const SUMMARY_COLUMNS = [
    { label: 'Tenant', key: 'tenant_name' },
    { label: 'Tcode', key: 'tenant_code' },
    { label: 'Location', key: 'property_name' },
    { label: 'Category', key: 'category_name' },
    { label: 'Gross', key: 'gross_sales', format: 'number' },
    { label: 'Tax', key: 'tax', format: 'number' },
    { label: 'Net', key: 'net_sales', format: 'number' },
    { label: 'Txn', key: 'txn' },
    { label: 'ATV', key: 'atv', format: 'number' },
    { label: 'Growth Daily %', key: 'growth_daily', format: 'percent' }
];

const DaywiseSalesTrendReportView = () => {

    if (localStorage.getItem("accessReports") !== "1") {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
    }

    const getYesterdayDate = () => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return yesterday.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    };

    const concessionaire_id = localStorage.getItem("concessionaireId");
    const property_access = localStorage.getItem("propertyAccess");
    const [propertyAccessNames, setPropertyAccesssNames] = useState('');
    const login_name = localStorage.getItem("loginName");
    const login_id = localStorage.getItem("loginId");
    const [startDate, setStartDate] = useState(getYesterdayDate());
    const [endDate, setEndDate] = useState(getYesterdayDate());
    const [properties, setProperties] = useState([]);
    const [categories, setCategories] = useState([]);
    const [group_name, setGroupName] = useState('');
    const [groups, setGroups] = useState([]);
    const [allSubcategories, setAllSubcategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [allTenants, setAllTenants] = useState([]);
    const [tenants, setTenants] = useState([]);
    const [property_id, setPropertyId] = useState('');
    const [category_id, setCategoryId] = useState('');
    const [subcategory_id, setSubcategoryId] = useState('');
    const [tenant_id, setTenantId] = useState('');
    const [ReportData, setReportData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(50);
    const [validationMessage, setValidationMessage] = useState('');
    const [loading, setLoading] = useState(false)
    const today = new Date().toISOString().split('T')[0];
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

    const [tooltip, setTooltip] = useState('');

    const handleMouseEnter = (text) => setTooltip(text);
    const handleMouseLeave = () => setTooltip('');

    const [selectedTenants, setSelectedTenants] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const dropdownRef = useRef(null);
    const [searchTenant, setSearchTenant] = useState('');
    const [expandedTenants, setExpandedTenants] = useState({});
    const [dailyDataMap, setDailyDataMap] = useState({});
    const [dailyLoading, setDailyLoading] = useState({});
    const isAnyExpanded = Object.values(expandedTenants).some(Boolean);
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const [exportMenuOpen, setExportMenuOpen] = useState(false);
    const exportRef = useRef(null);

    const [pdfMenuOpen, setPdfMenuOpen] = useState(false);
    const pdfRef = useRef(null);
    const formatNumber = (v) => typeof v === 'number' ? v.toLocaleString(undefined, { minimumFractionDigits: 2 }) : '';

    const token = localStorage.getItem("sessiontoken");
    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }

            if (exportRef.current && !exportRef.current.contains(event.target)) {
                setExportMenuOpen(false);
            }

            if (pdfRef.current && !pdfRef.current.contains(event.target)) {
                setPdfMenuOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside, true);
        return () => document.removeEventListener('click', handleClickOutside, true);
    }, []);


    useEffect(() => {
        axios
            .post(`${config.hostname}/property/getpropertybyconcessionaire`, { property_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setProperties(response.data);
                const propertyNames = response.data.map(property => property.property_name).join(',');
                setPropertyAccesssNames(propertyNames);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getgroupnames`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setGroups(response.data)
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/category/getcategorybyconcessionaire`, { category_concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setCategories(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);


    useEffect(() => {
        axios
            .post(`${config.hostname}/subcategory/getsubcategorybyconcessionaire`, { subcategory_concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setAllSubcategories(response.data);
                setSubcategories(response.data); // Initial set to all subcategories
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);


    useEffect(() => {
        let filteredSubcategories = allSubcategories;

        if (category_id !== '') {
            filteredSubcategories = filteredSubcategories.filter(subcategory => subcategory.category_id._id === category_id);
        }

        setSubcategories(filteredSubcategories);
    }, [category_id]);

    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getenantsbyconcessionaire`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setAllTenants(response.data);
                setTenants(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        let filteredTenants = allTenants;

        if (group_name !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_group_name === group_name);
        }

        if (category_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_category_id._id === category_id);
        }

        if (property_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_property_id._id === property_id);
        }

        if (subcategory_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_subcategory_id._id === subcategory_id);
        }

        setTenants(filteredTenants);
    }, [group_name, property_id, category_id, subcategory_id, allTenants]);

    const toggleExpandTenant = async (tenantId) => {
        setCurrentPage(0);
        setExpandedTenants(prev => {
            const willExpand = !prev[tenantId];

            if (willExpand && !dailyDataMap[tenantId]) {
                fetchDailyData(tenantId);
            }

            return {
                ...prev,
                [tenantId]: willExpand
            };
        });
    };


    const filteredTenants = tenants.filter((tenant) => {
        if (!searchTenant.trim()) return true;

        const search = searchTenant.trim().toLowerCase();

        const name = (tenant.tenant_store_name || "").toLowerCase();
        const code = (tenant.tenant_code || "").toLowerCase(); // or tenant.tenant_code / tenant_code

        return name.includes(search) || code.includes(search);
    });

    const fetchDailyData = async (tenantId) => {
        if (dailyDataMap[tenantId]) return;

        setDailyLoading(prev => ({ ...prev, [tenantId]: true }));

        try {
            const payload = {
                concessionaire_id,
                tenant_id: tenantId,
                start_date: startDate,
                end_date: endDate,
                property_name: property_id
                    ? properties.find(p => p._id === property_id)?.property_name
                    : ''
            };

            const res = await axios.post(
                `${config.hostname}/reports/getdailysalestrendreport/tenant`,
                payload,
                configheader
            );

            setDailyDataMap(prev => ({
                ...prev,
                [tenantId]: res.data.daily_sales || []
            }));
        } catch {
            toast.error('Failed to load daily data');
        } finally {
            setDailyLoading(prev => ({ ...prev, [tenantId]: false }));
        }
    };


    const generateReport = async (e) => {
        e.preventDefault();

        // Validation for start date and end date
        if (endDate < startDate) {
            setValidationMessage('End date cannot be less than start date');
            return;
        } else {
            setValidationMessage('');
        }

        setExpandedTenants({});
        setDailyDataMap({});
        setDailyLoading({})
        const category_name = category_id !== '' ? categories.find(category => category._id === category_id).category_name : '';
        const property_name = property_id !== '' ? properties.find(property => property._id === property_id).property_name : '';
        const subcategory_name = subcategory_id !== '' ? subcategories.find(subcategory => subcategory._id === subcategory_id).subcategory_name : '';
        const tenant_name = tenant_id !== '' ? tenants.find(tenant => tenant._id === tenant_id).tenant_store_name : '';

        const data = {
            concessionaire_id,
            property_access: propertyAccessNames,
            start_date: startDate,
            end_date: endDate,
            group_name,
            category_name,
            property_name,
            subcategory_name,
            tenant_id: selectedTenants,
            tenant_name,
        };

        setLoading(true)
        axios
            .post(`${config.hostname}/reports/getdailysalestrendreport/summary`, data, configheader)
            .then((response) => {
                setReportData(Array.isArray(response.data.tenants) ? response.data.tenants : []);
                setCurrentPage(0);
                setLoading(false)
                insertToLog(" generated Invoicewise report")
                console.log(response.data);
            })
            .catch((error) => {
                toast.error('Error');
                setLoading(false)
                console.log(error);
            });
    };

    const insertToLog = (task) => {
        const data = {
            created_by: login_id,
            concessionaire_id: concessionaire_id,
            module: "Reports",
            task: login_name + task
        }
        axios
            .post(`${config.hostname}/log`, data, configheader)
            .then(() => {
                console.log("inserted to log table")
            })
            .catch((error) => {
                toast.error('Error')
                console.log(error);

            });
    }


    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
        setExpandedTenants({});
        setDailyDataMap({});
        setDailyLoading({})
    };

    const handleEndDateChange = (e) => {
        setEndDate(e.target.value);
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
        setExpandedTenants({});
        setDailyDataMap({});
        setDailyLoading({})
    };

    const handleGroupChange = (e) => {
        setGroupName(e.target.value);
        setTenantId('');
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    const handlePropertyChange = (e) => {
        setPropertyId(e.target.value);
        setTenantId('');
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    const handleCategoryChange = (e) => {
        setCategoryId(e.target.value);
        setSubcategoryId('')
        setTenantId('');
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    const handleSubCategoryChange = (e) => {
        setSubcategoryId(e.target.value);
        setTenantId('')
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    // const handleTenantChange = (e) => {
    //     setTenantId(e.target.value);
    //     setReportData([]);
    //     setCurrentPage(0);
    // };


    const handleTenantChange = (e) => {
        const { value, checked } = e.target;

        setSelectedTenants((prev) => {
            if (checked) {
                // Add if not already there
                if (prev.includes(value)) return prev;
                return [...prev, value];
            } else {
                // Remove if unchecked
                return prev.filter((item) => item !== value);
            }
        });

        setReportData([]);
        setCurrentPage(0);
    };


    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };


    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
        setCurrentPage(0);
    };

    const getSortIcon = key => {
        if (sortConfig.key === key) {
            if (sortConfig.direction === 'asc') {
                return <FontAwesomeIcon icon={faSortUp} style={{ fontSize: '0.5em', fontWeight: 'normal' }} />;
            }
            if (sortConfig.direction === 'desc') {
                return <FontAwesomeIcon icon={faSortDown} style={{ fontSize: '0.5em', fontWeight: 'normal' }} />;
            }
        }

    };

    const sortedSummaryData = React.useMemo(() => {
        let data = [...ReportData];

        if (!sortConfig.key) return data;

        return data.sort((a, b) => {
            const aVal = a[sortConfig.key];
            const bVal = b[sortConfig.key];

            if (typeof aVal === 'number' && typeof bVal === 'number') {
                return sortConfig.direction === 'asc' ? aVal - bVal : bVal - aVal;
            }

            return sortConfig.direction === 'asc'
                ? String(aVal ?? '').localeCompare(String(bVal ?? ''))
                : String(bVal ?? '').localeCompare(String(aVal ?? ''));
        });
    }, [ReportData, sortConfig]);

    const flattenedRows = React.useMemo(() => {
        const rows = [];

        sortedSummaryData.forEach(summary => {
            // SUMMARY ROW
            rows.push({
                type: 'summary',
                tenant_id: summary.tenant_id,
                data: summary
            });

            // DAILY ROWS (if expanded)
            if (expandedTenants[summary.tenant_id]) {
                (dailyDataMap[summary.tenant_id] || []).forEach(d => {
                    rows.push({
                        type: 'daily',
                        tenant_id: summary.tenant_id,
                        data: d
                    });
                });
            }
        });

        return rows;
    }, [sortedSummaryData, expandedTenants, dailyDataMap]);

    const pageCount = Math.ceil(flattenedRows.length / itemsPerPage);

    const currentPageRows = flattenedRows.slice(
        currentPage * itemsPerPage,
        (currentPage + 1) * itemsPerPage
    );

    const handleExportHoverIn = (e) => {
        e.currentTarget.style.backgroundColor = '#00b1c2';
        e.currentTarget.style.color = '#ffffff';
    };

    const handleExportHoverOut = (e) => {
        e.currentTarget.style.backgroundColor = '#fff';
        e.currentTarget.style.color = '#000000';
    };

    const handleExport = async (format, mode) => {
        if (!ReportData.length) return;

        //  EXPORT CURRENT VIEW
        if (mode === 'visible') {
            if (format === 'excel') exportToExcel();
            else exportToPDF();
            return;
        }

        //  EXPORT FULL DETAILS (API)
        try {
            setLoading(true);

            const payload = {
                concessionaire_id,
                start_date: startDate,
                end_date: endDate,
                property_access: propertyAccessNames,
                property_name: property_id
                    ? properties.find(p => p._id === property_id)?.property_name
                    : '',
                category_name: category_id
                    ? categories.find(c => c._id === category_id)?.category_name
                    : '',
                subcategory_name: subcategory_id
                    ? subcategories.find(s => s._id === subcategory_id)?.subcategory_name
                    : '',
                group_name,
                tenant_id: selectedTenants,
                export_type: 'expanded'
            };

            const res = await axios.post(
                `${config.hostname}/reports/getdailysalestrendreport/export`,
                payload,
                configheader
            );

            if (format === 'excel') {
                exportExpandedExcel(res.data.rows);
            } else {
                exportExpandedPDF(res.data.rows);
            }

        } catch (err) {
            toast.error('Failed to export full report');
        } finally {
            setLoading(false);
            setExportMenuOpen(false);
            setPdfMenuOpen(false);
        }
    };


    const buildExportMetadata = () => {
        const meta = [];

        if (startDate === endDate) {
            meta.push(['Date', startDate]);
        } else {
            meta.push(['From Date', startDate]);
            meta.push(['To Date', endDate]);
        }

        meta.push([
            'Property',
            property_id
                ? properties.find(p => p._id === property_id)?.property_name
                : 'All'
        ]);

        meta.push([
            'Category',
            category_id
                ? categories.find(c => c._id === category_id)?.category_name
                : 'All'
        ]);

        meta.push([
            'Subcategory',
            subcategory_id
                ? subcategories.find(s => s._id === subcategory_id)?.subcategory_name
                : 'All'
        ]);

        meta.push(['Group', group_name || 'All']);
        meta.push(['Exported By', login_name]);
        meta.push(['Exported On', new Date().toLocaleString()]);

        return meta;
    };

    const buildExportRows = () => {
        const rows = [];
        const includeDate = Object.values(expandedTenants).some(Boolean);

        currentPageRows.forEach(row => {
            // ===== SUMMARY ROW =====
            const summaryRow = {
                Tenant: row.tenant_name,
                Tcode: row.tenant_code,
                Location: row.property_name,
                Category: row.category_name
            };

            if (includeDate) {
                summaryRow.Date = '-';
            }

            Object.assign(summaryRow, {
                Gross: row.gross_sales,
                Tax: row.tax,
                Net: row.net_sales,
                Txn: row.txn,
                ATV: row.atv,
                'Growth Daily %': row.growth_daily
            });

            rows.push(summaryRow);

            // ===== DAILY ROWS =====
            if (expandedTenants[row.tenant_id]) {
                (dailyDataMap[row.tenant_id] || []).forEach(d => {
                    rows.push({
                        Tenant: '',
                        Tcode: '',
                        Location: '',
                        Category: '',
                        Date: d.date,
                        Gross: d.gross_sales,
                        Tax: d.tax,
                        Net: d.net_sales,
                        Txn: d.txn,
                        ATV: d.atv,
                        'Growth Daily %': d.growth_daily
                    });
                });
            }
        });

        return rows;
    };

    const exportToExcel = () => {
        const rows = buildExportRows();
        if (!rows.length) return;

        const worksheet = XLSX.utils.aoa_to_sheet([]);

        // Title
        XLSX.utils.sheet_add_aoa(
            worksheet,
            [['Daily Sales Trend Report']],
            { origin: 'A1' }
        );

        // Metadata
        const metadata = buildExportMetadata();
        XLSX.utils.sheet_add_aoa(worksheet, metadata, { origin: 'A3' });

        const tableStartRow = metadata.length + 5;

        const headers = Object.keys(rows[0]);
        XLSX.utils.sheet_add_aoa(
            worksheet,
            [headers],
            { origin: `A${tableStartRow}` }
        );

        const body = rows.map(r => headers.map(h => r[h] ?? ''));
        XLSX.utils.sheet_add_aoa(
            worksheet,
            body,
            { origin: `A${tableStartRow + 1}` }
        );

        worksheet['!cols'] = headers.map(() => ({ wch: 18 }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Daily Sales Trend');

        XLSX.writeFile(workbook, 'DailySalesTrendReport.xlsx');
    };

    const exportToPDF = () => {
        const rows = buildExportRows();
        if (!rows.length) return;

        const doc = new jsPDF('l', 'pt', 'a4');

        doc.setFontSize(14);
        doc.text('Daily Sales Trend Report', 40, 30);

        doc.setFontSize(9);

        const metadata = buildExportMetadata();
        let y = 55;

        metadata.forEach(([label, value]) => {
            doc.text(`${label}: ${value}`, 40, y);
            y += 14;
        });

        const headers = Object.keys(rows[0]);
        const body = rows.map(r =>
            headers.map(h => {
                const v = r[h];
                if (typeof v === 'number') {
                    return v.toLocaleString(undefined, { minimumFractionDigits: 2 });
                }
                return v ?? '';
            })
        );

        doc.autoTable({
            startY: y + 10,
            head: [headers],
            body,
            styles: { fontSize: 8 },
            theme: 'grid',
            headStyles: { fillColor: [40, 40, 40], textColor: 255 }
        });

        doc.save('DailySalesTrendReport.pdf');
    };

    const exportExpandedExcel = (rows) => {
        if (!rows?.length) return;

        const worksheet = XLSX.utils.aoa_to_sheet([]);

        // Title
        XLSX.utils.sheet_add_aoa(
            worksheet,
            [['Daily Sales Trend Report (Full Details)']],
            { origin: 'A1' }
        );

        // Metadata
        const metadata = buildExportMetadata();
        XLSX.utils.sheet_add_aoa(worksheet, metadata, { origin: 'A3' });

        const tableStartRow = metadata.length + 5;

        const headers = [
            'Tenant',
            'Tcode',
            'Location',
            'Category',
            'Date',
            'Gross',
            'Tax',
            'Net',
            'Txn',
            'ATV',
            'Growth Daily %'
        ];

        XLSX.utils.sheet_add_aoa(
            worksheet,
            [headers],
            { origin: `A${tableStartRow}` }
        );

        const body = rows.map(r => [
            r.row_type === 'summary' ? r.tenant_name : '',
            r.row_type === 'summary' ? r.tenant_code : '',
            r.row_type === 'summary' ? r.property_name : '',
            r.row_type === 'summary' ? r.category_name : '',
            r.row_type === 'daily' ? r.date : '',
            r.gross_sales ?? '',
            r.tax ?? '',
            r.net_sales ?? '',
            r.txn ?? '',
            r.atv ?? '',
            r.growth_daily ?? ''
        ]);

        XLSX.utils.sheet_add_aoa(
            worksheet,
            body,
            { origin: `A${tableStartRow + 1}` }
        );

        worksheet['!cols'] = headers.map(() => ({ wch: 18 }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Daily Sales Trend');

        XLSX.writeFile(workbook, 'DailySalesTrendReport_Full.xlsx');
    };

    const exportExpandedPDF = (rows) => {
        if (!rows?.length) return;

        const doc = new jsPDF('l', 'pt', 'a4');

        doc.setFontSize(14);
        doc.text('Daily Sales Trend Report (Full Details)', 40, 30);

        doc.setFontSize(9);

        const metadata = buildExportMetadata();
        let y = 55;

        metadata.forEach(([label, value]) => {
            doc.text(`${label}: ${value}`, 40, y);
            y += 14;
        });

        const headers = [
            'Tenant',
            'Tcode',
            'Location',
            'Category',
            'Date',
            'Gross',
            'Tax',
            'Net',
            'Txn',
            'ATV',
            'Growth Daily %'
        ];

        const body = rows.map(r => [
            r.row_type === 'summary' ? r.tenant_name : '',
            r.row_type === 'summary' ? r.tenant_code : '',
            r.row_type === 'summary' ? r.property_name : '',
            r.row_type === 'summary' ? r.category_name : '',
            r.row_type === 'daily' ? r.date : '',
            formatNumber(r.gross_sales),
            formatNumber(r.tax),
            formatNumber(r.net_sales),
            r.txn ?? '',
            formatNumber(r.atv),
            r.growth_daily != null ? `${r.growth_daily.toFixed(2)}%` : ''
        ]);

        doc.autoTable({
            startY: y + 10,
            head: [headers],
            body,
            styles: { fontSize: 8 },
            theme: 'grid',
            headStyles: { fillColor: [40, 40, 40], textColor: 255 }
        });

        doc.save('DailySalesTrendReport_Full.pdf');
    };

    const reset = () => {
        setStartDate('')
        setEndDate('')
        setPropertyId('');
        setCategoryId('');
        setSubcategoryId('');
        setGroupName('');
        setTenantId('');
        setSelectedTenants([]);
        setSearchTenant('');
        setDropdownOpen(false);
        setReportData([]);
        setExpandedTenants({});
        setDailyDataMap({});
        setDailyLoading({})
    }

    return (
        <Fragment>
            <Form className='theme-form' onSubmit={generateReport}>
                <Card>
                    <CardBody>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="startdate">Start Date</Label>
                                    <input className="form-control digits"
                                        id="startdate" type="date" name="startdate" value={startDate}
                                        max={today} onChange={handleStartDateChange} required />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="enddate">End Date</Label>
                                    <input className="form-control digits"
                                        id="startdate" type="date" name="startdate" value={endDate}
                                        max={today} onChange={handleEndDateChange} required />
                                </FormGroup>
                                {validationMessage && (
                                    <span className="text-danger">{validationMessage}</span>
                                )}
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="property_id">Property</Label>
                                    <select name="property_id" id="property_id" className="form-control"
                                        value={property_id} onChange={handlePropertyChange}>
                                        <option value="">All</option>
                                        {properties.map(property => (
                                            <option key={property._id} value={property._id}>{property.property_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="category_id">Category</Label>
                                    <select name="category_id" id="category_id" className="form-control"
                                        value={category_id} onChange={handleCategoryChange}>
                                        <option value="">All</option>
                                        {categories.map(category => (
                                            <option key={category._id} value={category._id}>{category.category_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="subcategory_id">Sub Category</Label>
                                    <select name="subcategory_id" id="subcategory_id" className="form-control"
                                        value={subcategory_id} onChange={handleSubCategoryChange}>
                                        <option value="">All</option>
                                        {subcategories.map(subcategory => (
                                            <option key={subcategory._id} value={subcategory._id}>{subcategory.subcategory_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="subcategory_id">Group</Label>
                                    <select name="subcategory_id" id="subcategory_id" className="form-control"
                                        value={group_name} onChange={handleGroupChange}>
                                        <option value="">All</option>
                                        {groups.map((group, index) => (
                                            <option key={index} value={group}>{group}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>

                            <Col>
                                <div style={{ position: 'relative', width: '100%' }} ref={dropdownRef}>
                                    <label>Tenants</label>
                                    <div
                                        onClick={toggleDropdown}
                                        style={{
                                            border: '1px solid #ccc',
                                            padding: '8px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div>Select Tenants</div>
                                        <span style={{ marginLeft: 'auto' }}>&#9662;</span>
                                    </div>
                                    {dropdownOpen && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                width: '100%',
                                                backgroundColor: '#fff',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                marginTop: '4px',
                                                zIndex: 1,
                                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                                maxHeight: '250px', // Set the maximum height for the dropdown
                                                overflowY: 'auto' // Scrollable content
                                            }}
                                        >
                                            {/* Search Bar */}
                                            <div style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>
                                                <input
                                                    type="text"
                                                    placeholder="Search tenants..."
                                                    value={searchTenant}
                                                    onChange={(e) => setSearchTenant(e.target.value)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '6px',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px'
                                                    }}
                                                />
                                            </div>

                                            {/* Filtered Tenants List */}
                                            {filteredTenants.length > 0 ? (
                                                filteredTenants.map(tenant => (
                                                    <label
                                                        key={tenant._id}
                                                        style={{ display: 'block', padding: '8px', cursor: 'pointer' }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            value={tenant._id}
                                                            checked={selectedTenants.includes(tenant._id)}
                                                            onChange={handleTenantChange}
                                                            style={{ marginRight: '8px' }}
                                                        />

                                                        {/* 👇 Display code + name */}
                                                        <span style={{ fontWeight: 500 }}>
                                                            {tenant.tenant_store_name}
                                                            {tenant.tenant_code ? ` - ${tenant.tenant_code}` : ""}
                                                        </span>
                                                    </label>
                                                ))
                                            ) : (
                                                <div style={{ padding: '8px', color: 'gray', textAlign: 'center' }}>
                                                    No results found
                                                </div>
                                            )}

                                        </div>
                                    )}
                                </div>
                            </Col>

                        </Row>
                        <Row>
                            <Col >
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', type: "submit" }} >Generate Report</Btn>
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', onClick: reset }} >Reset</Btn>
                            </Col>

                        </Row>


                    </CardBody>
                </Card>
            </Form>
            {loading === true ? (
                <div className="loader-box">
                    <Spinner attrSpinner={{ className: 'loader-3' }} />
                </div>

            ) : (
                <Card>
                    <CardHeader>
                        <Row className="justify-content-end">
                            <Col xs="auto" style={{ position: 'relative' }}>
                                <Btn
                                    attrBtn={{
                                        color: 'primary',
                                        type: 'button',
                                        onClick: () => setExportMenuOpen(prev => !prev),
                                        onMouseEnter: () => handleMouseEnter('Export to Excel'),
                                        onMouseLeave: handleMouseLeave
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFileExcel} size="lg" />
                                </Btn>

                                {tooltip === 'Export to Excel' && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-30px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        padding: '5px 10px',
                                        borderRadius: '3px',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        zIndex: 20,
                                    }}>
                                        {tooltip}
                                    </div>
                                )}

                                {exportMenuOpen && (
                                    <div
                                        ref={exportRef}
                                        onClick={(e) => e.stopPropagation()}
                                        style={{
                                            position: 'absolute',
                                            right: 0,
                                            top: '110%',
                                            backgroundColor: '#fff',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            boxShadow: '0 4px 10px rgba(62, 31, 31, 0.15)',
                                            zIndex: 50,
                                            minWidth: '220px',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <div
                                            style={dropdownItemStyle}
                                            onMouseEnter={handleExportHoverIn}
                                            onMouseLeave={handleExportHoverOut}
                                            onClick={() => {
                                                handleExport('excel', 'visible');
                                                setExportMenuOpen(false);
                                            }}
                                        >
                                            📄 Export Current View
                                        </div>

                                        <div
                                            style={dropdownItemStyle}
                                            onMouseEnter={handleExportHoverIn}
                                            onMouseLeave={handleExportHoverOut}
                                            onClick={() => {
                                                handleExport('excel', 'expanded');
                                                setExportMenuOpen(false);
                                            }}
                                        >
                                            📊 Export Full Details
                                        </div>

                                    </div>
                                )}
                            </Col>

                            <Col xs="auto" style={{ position: 'relative' }}>
                                <Btn
                                    attrBtn={{
                                        color: 'primary',
                                        type: 'button',
                                        onClick: () => setPdfMenuOpen(prev => !prev),
                                        onMouseEnter: () => handleMouseEnter('Export to PDF'),
                                        onMouseLeave: handleMouseLeave
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFilePdf} size="lg" />
                                </Btn>

                                {tooltip === 'Export to PDF' && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-30px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        padding: '5px 10px',
                                        borderRadius: '3px',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        zIndex: 20,
                                    }}>
                                        {tooltip}
                                    </div>
                                )}

                                {pdfMenuOpen && (
                                    <div
                                        ref={pdfRef}
                                        onClick={(e) => e.stopPropagation()}
                                        style={{
                                            position: 'absolute',
                                            right: 0,
                                            top: '110%',
                                            backgroundColor: '#fff',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            boxShadow: '0 4px 10px rgba(62, 31, 31, 0.15)',
                                            zIndex: 50,
                                            minWidth: '220px',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <div
                                            style={dropdownItemStyle}
                                            onMouseEnter={handleExportHoverIn}
                                            onMouseLeave={handleExportHoverOut}
                                            onClick={() => {
                                                handleExport('pdf', 'visible');
                                                setPdfMenuOpen(false);
                                            }}
                                        >
                                            📄 Export Current View
                                        </div>

                                        <div
                                            style={dropdownItemStyle}
                                            onMouseEnter={handleExportHoverIn}
                                            onMouseLeave={handleExportHoverOut}
                                            onClick={() => {
                                                handleExport('pdf', 'expanded');
                                                setPdfMenuOpen(false);
                                            }}
                                        >
                                            📊 Export Full Details
                                        </div>
                                    </div>
                                )}
                            </Col>

                        </Row>

                    </CardHeader>
                    <CardBody>
                        <Col sm="12" lg="12" xl="12">
                            <div className="table-responsive" >
                                <Table style={{ tableLayout: 'auto', whiteSpace: 'nowrap' }}>
                                    <thead>
                                        <tr>
                                            <th>Daily</th> {/* Expand column */}

                                            {SUMMARY_COLUMNS.map(col => (
                                                <Fragment key={col.key}>
                                                    <th
                                                        onClick={() =>
                                                            setSortConfig(prev => ({
                                                                key: col.key,
                                                                direction:
                                                                    prev.key === col.key && prev.direction === 'asc'
                                                                        ? 'desc'
                                                                        : 'asc'
                                                            }))
                                                        }
                                                        style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                                    >
                                                        {col.label}
                                                        {sortConfig.key === col.key && (
                                                            <FontAwesomeIcon
                                                                icon={sortConfig.direction === 'asc' ? faSortUp : faSortDown}
                                                                style={{ fontSize: '0.6em', marginLeft: 4 }}
                                                            />
                                                        )}
                                                    </th>

                                                    {/* Date column only when expanded */}
                                                    {col.key === 'category_name' && isAnyExpanded && <th>Date</th>}
                                                </Fragment>
                                            ))}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {currentPageRows.map((row, idx) => {

                                            /* ===== SUMMARY ROW ===== */
                                            if (row.type === 'summary') {
                                                const r = row.data;

                                                return (
                                                    <tr key={`s-${idx}`} style={{ background: '#f8f9fa' }}>
                                                        <td>
                                                            <Btn
                                                                attrBtn={{
                                                                    size: 'sm',
                                                                    color: 'primary',
                                                                    onClick: () => toggleExpandTenant(r.tenant_id)
                                                                }}
                                                            >
                                                                {expandedTenants[r.tenant_id] ? '−' : '+'}
                                                            </Btn>
                                                        </td>

                                                        {SUMMARY_COLUMNS.map(col => (
                                                            <Fragment key={col.key}>
                                                                <td>
                                                                    {col.format === 'number'
                                                                        ? r[col.key]?.toLocaleString(undefined, { minimumFractionDigits: 2 })
                                                                        : col.format === 'percent'
                                                                            ? r[col.key] != null ? `${r[col.key].toFixed(2)}%` : '-'
                                                                            : r[col.key] || ''}
                                                                </td>

                                                                {col.key === 'category_name' && isAnyExpanded && <td>-</td>}
                                                            </Fragment>
                                                        ))}
                                                    </tr>
                                                );
                                            }

                                            /* ===== DAILY ROW ===== */
                                            const d = row.data;

                                            return (
                                                <tr key={`d-${idx}`}>
                                                    <td></td>

                                                    {SUMMARY_COLUMNS.map(col => (
                                                        <Fragment key={col.key}>
                                                            <td>
                                                                {col.key === 'gross_sales' ? d.gross_sales?.toLocaleString(undefined, { minimumFractionDigits: 2 })
                                                                    : col.key === 'tax' ? d.tax?.toLocaleString(undefined, { minimumFractionDigits: 2 })
                                                                        : col.key === 'net_sales' ? d.net_sales?.toLocaleString(undefined, { minimumFractionDigits: 2 })
                                                                            : col.key === 'txn' ? d.txn
                                                                                : col.key === 'atv' ? d.atv?.toLocaleString(undefined, { minimumFractionDigits: 2 })
                                                                                    : col.key === 'growth_daily'
                                                                                        ? d.growth_daily != null ? `${d.growth_daily.toFixed(2)}%` : '-'
                                                                                        : ''}
                                                            </td>

                                                            {col.key === 'category_name' && isAnyExpanded && (
                                                                <td><strong>{d.date}</strong></td>
                                                            )}
                                                        </Fragment>
                                                    ))}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </div>
                            {pageCount > 1 && (
                                <ReactPaginate
                                    previousLabel={'<<'}
                                    nextLabel={'>>'}
                                    breakLabel={'...'}
                                    breakClassName={'break-me'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                />
                            )}

                        </Col>
                    </CardBody>
                </Card>
            )}
        </Fragment>
    );
};

export default DaywiseSalesTrendReportView;
